import axios from "axios";
export const BASE_URL = "https://gramthan.hamropalika.org";
export const baseURLAPI = "https://gramthan.hamropalika.org/api";
export default axios.create({
    baseURL: `${BASE_URL}/api/website/cache/`,
});
